import { MinusCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import { Col, Collapse, Flex, Tag } from "antd";
import Loading from "components/loading/Loading";
import { apiGetNotice, apiGetNotices } from "helpers/api/notices";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserInfo, showToastError } from "utils";
import "./styles.scss";

const NotificationPage = () => {
  const { t } = useTranslation();
  const userInfo = getUserInfo();
  const [loading, setLoading] = useState(false);
  const [notices, setNotices] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });
  const [activeKeys, setActiveKeys] = useState([]);

  const getNotices = (newPage) => {
    setLoading(true);
    apiGetNotices({
      page: newPage || notices.page,
      limit: 15,
    })
      .then((res) => {
        setNotices(res);
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const readNoticesHandle = (id, isRead) => {
    if (id && !isRead) {
      apiGetNotice(id).then((res) => {
        if (res.data) getNotices();
      });
    }
  };

  const handleExpand = (key) => {
    setActiveKeys((prevActiveKeys) =>
      prevActiveKeys.includes(key)
        ? prevActiveKeys.filter((activeKey) => activeKey !== key)
        : [...prevActiveKeys, key]
    );
  };

  useEffect(() => {
    getNotices();
  }, []);

  return (
    <div className="main-content notification-container">
      <div className="root-right-header">
        <div className="screen-name">
          {userInfo?.clinic_name + ` ${t("notification.clinicNote")}`}
        </div>
      </div>
      <div className="bg-white">
        <div className="screen-subject">{t("notification.title")}</div>
        <div className="collapse-item-container">
          {notices.data.length > 0
            ? notices.data.map((item) => (
                <Collapse
                  key={item.id}
                  activeKey={activeKeys}
                  onChange={(keys) => setActiveKeys(keys)}
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <MinusCircleFilled
                        className="icon-style"
                        style={{ fontSize: "25px" }}
                      />
                    ) : (
                      <PlusCircleFilled
                        className="icon-style"
                        style={{ fontSize: "25px" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleExpand(item.id);
                          readNoticesHandle(item.id, item.read);
                        }}
                      />
                    )
                  }
                  bordered={false}
                  className="collapse-style"
                >
                  <Collapse.Panel
                    header={
                      <div
                        className="label-info"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="label-content">
                          <Tag
                            color={item.read ? "#7ED957" : "#FF3131"}
                            style={{ borderRadius: "10px" }}
                          >
                            {item.read
                              ? t("notification.isRead")
                              : t("notification.notRead")}
                          </Tag>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleExpand(item.id);
                              readNoticesHandle(item.id, item.read);
                            }}
                          >
                            {item.subject}
                          </span>
                        </div>
                        <div className="label-date">
                          {moment(item.release_date).format("YYYY/MM/DD")}
                        </div>
                      </div>
                    }
                    key={item.id}
                  >
                    <div className="div-collapse-container">
                      <div className="div-collapse-subject" dangerouslySetInnerHTML={{__html: item.content}} />
                    </div>
                  </Collapse.Panel>
                </Collapse>
              )) : (
                <div className="ant-list-empty-text">データがありません</div>
              )}
        </div>
        {notices.data.length > 0 && 
        <div className="pagination-container">
          <Col style={{ display: "flex" }}>
            {`${notices.page}/${notices.total_page} ${t("pagination")}　`}
            <Flex gap="10px">
              {notices.page > 1 ? (
                <span
                  style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                  onClick={() => {
                    setNotices((prev) => ({ ...prev, page: prev.page - 1 }));
                    getNotices(notices.page - 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
              {notices.page < notices.total_page ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setNotices((prev) => ({ ...prev, page: prev.page + 1 }));
                    getNotices(notices.page + 1);
                  }}
                >
                  ▶
                </span>
              ) : null}
            </Flex>
          </Col>
        </div>
        }
      </div>
      {loading && <Loading />}
    </div>
  );
};

export default NotificationPage;
